import constants from "../../../../../../appConstants";
import { MultiSelectFilter } from "../../../../../dataGrid/columnFilters";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration(config);
  }

  static driverValueGetter({ data: { driverName, driverNumber } }) {
    return `${driverName} ${driverNumber ? "(" + driverNumber + ")" : ""}`;
  }

  static getDefaultConfiguration(config) {
    return {
      keyColumn: "",
      rowSelection: "multiple",
      rowDeselection: true,
      suppressRowTransform: true,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
        editable: false,
        lockPosition: true,
      },
      columns: [
        {
          headerName: "Pro#",
          field: "proNumber",
          headerTooltip: "Pro Number",
          width: constants.columnWidth.PICKUP_NUMBER,
          cellClass: "gridCell-leftAlign",
          pinned: "left",
          lockPosition: true,
          filterFramework: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: "Customer",
          field: "customerName",
          headerTooltip: "Customer Name",
          width: constants.columnWidth.CUSTOMER_CODE,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          tooltipField: "customerName",
        },
        {
          headerName: "City",
          field: "city",
          headerTooltip: "City",
          width: constants.columnWidth.CITY,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          tooltipField: "city",
        },
        {
          headerName: "Return Code",
          width: constants.columnWidth.RETURN_CODE,
          valueGetter: (params) => params.data.returnDetail.returnCode,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          headerTooltip: "Return Reason",
        },
        {
          headerName: "Driver",
          headerTooltip: "Driver Name",
          width: constants.columnWidth.DISPATCH_DRIVER_NAME,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          valueGetter: GridConfig.driverValueGetter,
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: "Arrival Time",
          field: "arrivalTime",
          headerTooltip: "Arrival Time",
          width: constants.columnWidth.ARRIVAL_TIME,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Departure Time",
          field: "departureTime",
          headerTooltip: "Departure Time",
          width: constants.columnWidth.DEPARTURE_TIME,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Contact Name",
          valueGetter: (params) => params.data.returnDetail.customerName,
          width: constants.columnWidth.CUSTOMER_NAME,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          headerTooltip: "Contact Name",
          tooltipValueGetter: (params) => params.value,
        },
      ],
    };
  }
}
